var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransferRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.202148,
    y: 0.589844,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#42DCA4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10653_14109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70215 6.08984H4.70215C4.40215 6.08984 4.20215 6.28984 4.20215 6.58984C4.20215 6.88984 4.40215 7.08984 4.70215 7.08984H9.70215V8.58984L12.2021 6.58984L9.70215 4.58984V6.08984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70215 11.0898H11.7021C12.0021 11.0898 12.2021 10.8898 12.2021 10.5898C12.2021 10.2898 12.0021 10.0898 11.7021 10.0898H6.70215V8.58984L4.20215 10.5898L6.70215 12.5898V11.0898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10653_14109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4.20215 4.58984)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferRounded);
export default __webpack_public_path__ + "static/media/transfer-rounded.d1710e403be7afe24da53badd7c92d90.svg";
export { ForwardRef as ReactComponent };